// mapping from https://docs.google.com/spreadsheets/d/1AHytVzCIXOzxpJgSMBjR7FXNRfJmbJiBc6oU4v7o6Gg/edit#gid=0
export enum TokenizationErrorCodes {
  InvalidExpirationDate = 3014,
  InvalidCardNumber = 3015,
  InvalidCVV = 3016,
  CardTypeIsNotSupported = 3017,
  ThreeDSecureFailed = 3004,
  GeneralTokenizationError = 3021,
  NonTestCardInTestMode = 3048,
  InvalidZipCode = 4003,
  GeneralValidationError = 1004,
}
